import angular from 'angular';
import inputIconDirective from './inputIconDirective';
import './inputIconStyles.css';

angular
	.module('sh.inputIcon', [])
	// <input type=text class=form-input sh-input-icon=search sh-input-icon-side=left>
	.directive('shInputIcon', inputIconDirective);
